<template>
    <div class="basicData" v-wechat-title="$t('故障类型维护')">
        <Title :title="$t('故障类型维护')"/>
        <div class="common_title add_account">{{ $t('故障分类') }}</div>
        <div class="content">
          <div class="left">
            <div class="tree_opt">
              <div v-show="breadList.length">
                <button type="button" class="normal_gray_btn ise-mr10" @click="add(1)" v-show="level === 0" v-permissions="26030207">{{ $t('添加一级分类') }}</button>
                <button type="button" class="normal_gray_btn ise-mr10" @click="add(2)" v-show="level === 1" v-permissions="26030207">{{ $t('添加二级分类') }}</button>
                <button type="button" class="normal_gray_btn ise-mr10" @click="add(3)" v-show="level === 2" v-permissions="26030207">{{ $t('添加三级分类') }}</button>
                <button type="button" class="normal_gray_btn ise-mr10" @click="add(4)" v-show="level === 3" v-permissions="26030207">{{ $t('添加四级分类') }}</button>
                <button type="button" class="normal_gray_btn" @click="del()" v-show="level !== 0" v-permissions="26030208">{{ $t('删除') }}</button>
              </div>
            </div>
            <div class="tree_box">
              <ise-tree :data="treeData" node-key="id" :props="treeOpt" ref="tree" lazy :load="loadNode" :default-expanded-keys="[0]" @node-click="nodeClick"  :render-content="renderContent"></ise-tree>
            </div>
          </div>
          <div class="right" v-show="editLevel > 0">
            <div class="breadcrumb">
              <span v-for="(item, index) in breadList" :key="index" :title="item">{{(item.length > 16 ? item.substring(0, 16) + '...' : item) + (index === breadList.length - 1 ? '' : ' > ')}}</span>
            </div>
            <div class="edit_box">
              <div class="edit_item">
                <span class="edit_label">{{$t('一级分类')}}</span>
                <div class="edit_input"><el-input  v-model.trim="lvInput.level1" :disabled="editLevel !== 1" maxlength="60"></el-input></div>
              </div>
              <div class="edit_item">
                <div class="item_line">
                  <span class="edit_label">{{$t('二级分类')}}</span>
                  <div class="edit_input"><el-input  v-model.trim="lvInput.level2" :disabled="editLevel !== 2" maxlength="60"></el-input></div>
                </div>
                <div class="item_line">
                  <span class="edit_label">是否为严重故障</span>
                  <div class="edit_input">
                    <el-select  v-model="severeMalfunction.level2" :disabled="editLevel !== 2" size="mini">
                      <el-option label="是" :value="1"></el-option>
                      <el-option label="否" :value="0"></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="edit_item">
                <div class="item_line">
                  <span class="edit_label">{{$t('三级分类')}}</span>
                  <div class="edit_input"><el-input  v-model.trim="lvInput.level3" :disabled="editLevel !== 3" maxlength="60"></el-input></div>
                </div>
                <div class="item_line">
                  <span class="edit_label">是否为严重故障</span>
                  <div class="edit_input">
                    <el-select  v-model="severeMalfunction.level3" :disabled="editLevel !== 3" size="mini">
                      <el-option label="是" :value="1"></el-option>
                      <el-option label="否" :value="0"></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="edit_item">
                <div class="item_line">
                  <span class="edit_label">{{$t('四级分类')}}</span>
                  <div class="edit_input"><el-input v-model.trim="lvInput.level4" :disabled="editLevel !== 4" maxlength="60"></el-input></div>
                </div>
                <div class="item_line">
                  <span class="edit_label">是否为严重故障</span>
                  <div class="edit_input">
                    <el-select  v-model="severeMalfunction.level4" :disabled="editLevel !== 4" size="mini">
                      <el-option label="是" :value="1"></el-option>
                      <el-option label="否" :value="0"></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="edit_btn_box" v-show="editLevel > 0">
            <button type="button" class="save_btn" @click="save" v-permissions="26030207">{{ $t('保存') }}</button>
          </div>
        </div>
    </div>
</template>

<script>
    import Cookie from 'js-cookie'
    import { mapState } from 'vuex'
    export default {
        data () {
            return {
                list: [],
                pageInfo: {
                  total: 0
                },
                lvInput: {
                  level1: '',
                  level2: '',
                  level3: '',
                  level4: ''
                },
                severeMalfunction: {
                  level2: 1,
                  level3: 1,
                  level4: 1
                },
                treeOpt: {
                  label: 'name',
                  isLeaf: 'leaf'
                },
                treeData: [{
                  level: 0,
                  id: 0,
                  name: this.$t('所有类型')
                }],
                level: 0,
                breadList: [],
                breadcrumb: '',
                breadAll: [],
                editLevel: 0,
                creatTime: false // 是否新建
            }
        },
        computed: {
          ...mapState({
            lang: state => state.common.lang
          })
        },
        mounted () {
          let lang = Cookie.get('isesol_lang')
          this.$store.commit('m:common/setLang', lang)
        },
        watch: {
          lang () {
            let node = this.$refs.tree.getNode(0)
            node.data.name = this.$t('所有类型')
            node.loaded = false
            node.expand()
            this.nodeClick(node.data)
          }
        },
        methods: {
            // 树结构懒加载
            loadNode (node, resolve) {
              if (node.level === 0) {
                return resolve([{
                  level: 0,
                  id: 0,
                  name: this.$t('所有类型')
                }]);
              } else {
                this.getTree(node, resolve)
              }
            },
            // 获取树节点内容
            getTree (node, resolve) {
              this.$store.dispatch('a:breakdownTpyeMaintain/getFaultLevelsByParentId', {parentId: node.data.id}).then(
                res => {
                  if (node.level === 4) {
                    let list = []
                    for (let item of res) {
                      list.push({...item, leaf: true})
                    }
                    return resolve(list)
                  } else {
                    return resolve(res)
                  }
                },
                rej => {
                  this.$message.error(rej.errorInfo);
                }
              )
            },
            // 点击书节点,获取节点信息
            nodeClick (data) {
              this.level = data.level
              let tree = this.$refs.tree
              this.breadList = []
              this.breadAll = []
              this.getTreeNode(tree.getNode(data))
              for (let i = 1; i < 5; i++) {
                this.lvInput['level' + i] = this.breadList[i] ? this.breadList[i] + '' :  ''
                
                if(i !== 1){
                  this.severeMalfunction['level' + i] = this.breadAll[i] ? this.breadAll[i].data.severeMalfunction : 1
                }
              }
              this.editLevel = this.breadList.length - 1
            },
            getTreeNode(node){ //获取当前树节点和其父级节点
              if (node) {
                if (node.label !== undefined) {
                  this.breadList.unshift(node.label) //在数组头部添加元素
                  this.breadAll.unshift(node) //在数组头部添加元素
                  this.getTreeNode(node.parent) //递归
                }
              }
            },
            // 添加分类
            add (level) {
              this.creatTime = true
              this.editLevel = level
            },
            // 删除分类
            del(data) {
              this.$confirm(this.$t('删除后无法恢复，确认删除该条记录'), this.$t('删除确认'), {
                confirmButtonText: this.$t('确认'),
                confirmButtonClass: 'save__btn',
                cancelButtonText: this.$t('取消'),
                cancelButtonClass: 'back__btn',
                type: 'warning',
                center: true,
                showClose: false
              }).then(() => {
                this.creatTime = false
                this.editLevel = this.level
                let param = {
                  validity: '0',
                  faultId: this.breadAll[this.breadAll.length - 1].data.id
                }
                this.$store.dispatch('a:breakdownTpyeMaintain/deleteorrecover', param).then(
                  res => {
                    let node = this.$refs.tree.getNode(this.breadAll[this.breadAll.length - 2].data.id)
                    node.loaded = false
                    node.expand()
                    this.nodeClick(this.breadAll[this.breadAll.length - 2].data)
                  },
                  rej => {
                    this.$message.error(rej.errorInfo);
                  }
                )
              })
            },
            // 保存分类
            save () {
              let param, cmd
              if (!this.lvInput['level' + this.editLevel]) {
                this.$alert(this.$t('请填写故障类别名称'), {
                    title: this.$t('提示'),
                    confirmButtonText: this.$t('确定')
                })
                return
              }
              if (this.creatTime) {
                param = {
                  code: '',
                  fault: this.lvInput['level' + this.editLevel],
                  level: this.editLevel,
                  parentId: this.breadAll[this.level].data.id
                }
                if(this.editLevel !== 1){
                  param.severeMalfunction = this.severeMalfunction['level' + this.editLevel]
                }
                cmd = 'a:breakdownTpyeMaintain/create'
              } else {
                param = {
                  code: '',
                  fault: this.lvInput['level' + this.editLevel],
                  level: this.editLevel,
                  faultId: this.breadAll[this.level].data.id,
                  parentId: this.breadAll[this.level].data.parentId
                }
                if(this.editLevel !== 1){
                  param.severeMalfunction = this.severeMalfunction['level' + this.editLevel]
                }
                cmd = 'a:breakdownTpyeMaintain/update'
              } 
              this.$store.dispatch(cmd, param).then(
                res => {
                  if (this.creatTime) {
                    let node = this.$refs.tree.getNode(this.breadAll[this.breadAll.length - 1].data.id)
                    node.loaded = false
                    node.expand()
                    this.lvInput['level' + this.editLevel] = ''
                    if(this.editLevel !== 1){
                      this.severeMalfunction['level' + this.editLevel] = 1
                    }
                    this.editLevel--
                    this.creatTime = false
                  } else {
                    let node = this.$refs.tree.getNode(this.breadAll[this.breadAll.length - 2].data.id)
                    node.loaded = false
                    node.expand()
                    setTimeout(() =>{
                      let newNode = this.$refs.tree.getNode(this.breadAll[this.breadAll.length - 1].data.id)
                      this.breadList = []
                      this.breadAll = []
                      this.getTreeNode(newNode)
                    }, 500)
                  }
                },
                rej => {
                  this.$message.error(rej.errorInfo);
                }
              )
            },
            // 启用禁用渲染
            renderContent (h, {node, data}) {
              return (<span class="custom-tree-node" title={node.label}>{node.label}</span>);
            }
        }
    }
</script>

<style>
  .ise-tree .el-tree-node__label{
    font-size: 12px;
  }
  .custom-tree-node{
    font-size: 12px;
    display: inline-block;
    width:200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
</style>

<style lang="scss" scoped>
.content{
  width: 100%;
  border-top: 2px solid #fabf40;
  margin-top: 1px;
  overflow: hidden;
}
.left{
  box-sizing: border-box;
  width: 340px;
  height: 331px;
  max-height: 331px;
  overflow: hidden;
  background-color: #FFFFFF;
  float: left;
  border-bottom: 1px solid #F1F2F6;
  margin-left: 20px;
}
.right{
  width: 900px;
  height: 330px;
  overflow: hidden;
  border-bottom: 1px solid #F1F2F5;
  float: right;
}
.tree_opt{
  width: 100%;
  height: 34px;
  border-bottom: 1px solid #F1F2F5;
  text-align: center;
  padding-top: 6px;
}
.tree_box{
  width: 300px;
  padding: 0 20px;
  height: 290px;
  overflow-x: hidden;
  overflow-y: auto;
}
.breadcrumb{
  height: 38px;
  line-height: 22px;
  font-weight: bold;
  background-color: #EFF3F6;
  overflow: hidden;
  padding: 8px 25px;
  box-sizing: border-box;
  margin-top: 1px;
  margin-bottom: 1px;
  width: 100%;
  font-size: 12px;
  font-weight: normal;
}
.edit_box{
  width: 100%;
  height: 290px;
  border-top: 1px solid #FEECC6;
  overflow: hidden;
}
.edit_item{
  width: 42%;
  height: 115px;
  padding-left: 4%;
  float: left;
  padding-top: 30px;
  .item_line{
    margin-bottom: 5px;
    .el-select{
      width: 100%;
    }
  }
}
.edit_label{
  width: 90px;
  text-align: right;
  font-size: 12px;
  line-height: 24px;
  display: inline-block;
  margin-right: 10px;
}
.edit_input{
  width: 200px;
  display: inline-block;
}
.ctrl-box{
  width: 100%;
}
</style>
